import dayjs from "dayjs";
import { Project } from "../../types/ProfessionalAffiliation";

export const extractYearMonth = (
  dateRange: string,
  position: "first" | "second"
): string => {
  const dates = dateRange.split(" - ");
  const targetDate = position === "first" ? dates[0] : dates[1];

  if (!targetDate) {
    return "";
  }

  return targetDate.slice(0, 7);
};

export const formatDate = (
  dateString: string,
  isEducationPeriod: boolean = false,
  isCertificationPeriod: boolean = false
) => {
  if (!dateString) return "";

  const [startStr, endStr] = dateString.split(" - ");
  const startDate = dayjs(startStr);
  const endDate = dayjs(endStr);
  const currentDate = dayjs();

  const formattedStart = startDate.isValid()
    ? isEducationPeriod
      ? startDate.format("YYYY")
      : startDate.format("MMMM YYYY")
    : startStr;

  let formattedEnd = "";

  if (!endStr) {
    if (isCertificationPeriod) {
      // certification without end date - show only start
      return formattedStart;
    } else {
      // not certification and no end date - show Present
      formattedEnd = "Present";
    }
  } else {
    // end date is provided
    formattedEnd =
      endDate.isValid() &&
      (endDate.isAfter(currentDate, "month") ||
        endDate.isSame(currentDate, "month"))
        ? "Present"
        : isEducationPeriod
        ? endDate.format("YYYY")
        : endDate.format("MMMM YYYY");
  }

  if (isEducationPeriod) {
    return `from ${formattedStart} - to ${formattedEnd}`;
  }

  return `${formattedStart}${formattedEnd ? ` - ${formattedEnd}` : ""}`;
};

export const sortProjectsByDate = (projects: Project[]): Project[] =>
  [...projects].sort((a, b) => {
    const aDate = a.projectPeriod ? dayjs(a.projectPeriod.split(" - ")[0]) : null;
    const bDate = b.projectPeriod ? dayjs(b.projectPeriod.split(" - ")[0]) : null;
    if (!aDate?.isValid()) return 1;
    if (!bDate?.isValid()) return -1;
    return bDate.valueOf() - aDate.valueOf();
  });

/**
 * Joins project roles for display. Cleans empty slots, leading/trailing commas
 * on each part, and legacy values where the whole field was one comma-separated string.
 */
export function formatProjectPositionHeading(
  position: string[] | string | undefined | null
): string {
  if (position == null) return "";

  const parts: string[] = Array.isArray(position)
    ? position.map((p) => String(p ?? ""))
    : String(position)
        .split(",")
        .map((s) => s.trim());

  const normalized = parts
    .map((p) =>
      p
        .replace(/^\s*,+/g, "")
        .replace(/,+\s*$/g, "")
        .trim()
    )
    .filter((p) => p.length > 0);

  return normalized.join(", ").replace(/^\s*,+/, "").trim();
}
